import React, { useEffect, useState } from 'react';
import axios from 'axios';
import parse from 'html-react-parser';
import { Html } from 'react-pdf-html';
import {
   PDFDownloadLink,
   PDFViewer,
   Document,
   Page,
   Image,
   Text,
   View,
   StyleSheet,
   Link,
   Font,
} from '@react-pdf/renderer';
import { chunkArray, groupByCategory ,fetchProducts,renderHeader,renderFooter} from './helpers';
import { CatalogShopGridPDF} from './CatalogShopGridPDF';
import { createStyles, loadFonts } from './pdfStylesGrid';



function CatalogShopGrid() {
   const [products, setProducts] = useState([]);
   const [settings, setSettings] = useState(window.GMWCP_PDF_DATA);
   const [isLoading, setIsLoading] = useState(true);
   const [currentPage, setCurrentPage] = useState(1);
   const [totalPages, setTotalPages] = useState(1);
   const [siteUrl, setSiteUrl] = useState(window.GMWCP_PDF_DATA['site_url']);
   const [pluginUrl, setPluginUrl] = useState(window.GMWCP_PDF_DATA['pluginurl']); 
   const [restapiUrl, setRestApiUrl] = useState(window.GMWCP_PDF_DATA['rest_api_url']); 
   const [rest_api_product, setRestApiProductUrl] = useState(window.GMWCP_PDF_DATA['rest_api_product']);  
   const [error, setError] = useState('');

   useEffect(() => {
      if (!siteUrl) return; // Exit early if siteUrl is empty

      loadFonts(pluginUrl);
   }, [siteUrl]);

   useEffect(() => {
      if (!siteUrl) return; 
      fetchProducts(rest_api_product, setProducts, setCurrentPage, setTotalPages, setError, setIsLoading);
   }, [siteUrl]);

  



   const ProductViewPdf = ({ products }) => {
      const styles = createStyles(settings);

      if (error) {
         return (
            <Document>
               <Page size="A4">
                  <View style={styles.body}>
                     <Text>Error: {error}</Text>
                  </View>
               </Page>
            </Document>
         );
      }

      if (!products || products.length === 0 || !settings) return null;

      const pageBreak = parseInt(settings.setting?.gmwcp_shop_pagebreak, 10) || 1;
      const shop_per_row_grid = parseInt(settings.setting?.gmpcp_shop_per_row_grid, 10) || 1;
      
      const gmwcp_shop_show_category_wise = settings.setting?.gmwcp_shop_show_category_wise;
       console.log("gmwcp_shop_show_category_wise",gmwcp_shop_show_category_wise);
      if (gmwcp_shop_show_category_wise=='yes') {
        const categoryWiseProducts = groupByCategory(products);
        console.log("categoryWiseProducts",categoryWiseProducts);
        return (
          <Document>
            {Object.entries(categoryWiseProducts).map(([categoryName, categoryProducts], categoryIndex) => {
              const categoryChunks = chunkArray(categoryProducts, pageBreak, shop_per_row_grid);
              
              return categoryChunks.map((page, chunkIndex) => (
              <Page style={styles.body} wrap={false}>
                
                {renderHeader(styles,settings)}  
                
                <View style={styles.contentContainermaincolor} >
                    {chunkIndex === 0 && (
                       <View style={styles.categoryTitle}>
                          <Text>{categoryName}</Text>
                       </View>
                    )}
                    <View  style={[styles.contentpartmain]}>

                      
                      {/* Loop through each row within the page */}
                      {page.map((row, rowIndex) => (
                          CatalogShopGridPDF(styles, settings, row, rowIndex)
                      ))}

                    </View>
                </View>
                {renderFooter(styles,settings)}
                
              </Page>
            ));
           })}
          </Document>
        );
      }else{
        const productChunks = chunkArray(products, pageBreak, shop_per_row_grid);
        return (
        <Document>
          {productChunks.map((page, chunkIndex) => (
            <Page key={chunkIndex}  style={styles.body} wrap={false}>
              
              {renderHeader(styles,settings)}
              <View style={styles.contentContainermaincolor} >
                <View  style={[styles.contentpartmain]}>
                  {/* Loop through each row within the page */}
                  {page.map((row, rowIndex) => (
                      CatalogShopGridPDF(styles, settings, row, rowIndex)
                  ))}
                </View>
              </View>
              {renderFooter(styles,settings)}
            </Page>
          ))}
        </Document>
      );
      }
   };

   return (
      <div className="gmwcpApp">
         {isLoading ? (
            <div>
               <div class="loader"></div>
               <div class="loading-text">
               {settings.setting?.gmpcp_trasnlation_loadding_products} {currentPage} of {totalPages}
               </div>
            </div>
         ) : (
         <>
            <PDFDownloadLink
                document={<ProductViewPdf products={products} />}
                fileName={`${settings.setting?.gmwcp_shop_download_file_name || 'Download'}.pdf`}
            >
                {({ loading }) => (
                    <button className="pdf-download-button">
                        {loading
                            ? settings.setting?.gmpcp_trasnlation_loadding_documents
                            : settings.setting?.gmpcp_trasnlation_category || 'Download'}
                    </button>
                )}
            </PDFDownloadLink>

            <PDFViewer style={{ width: '100%', height: '100vh' }}>
               <ProductViewPdf products={products} />
            </PDFViewer>
            </>
         )}
      </div>
   );
}

export default CatalogShopGrid;